import type { UserInfo } from "@memorang/types";

export const mergeUserInfo = (
	userInfo?: UserInfo,
	authUser?: {
		username: string | null;
		emailAddresses: { emailAddress: string }[];
		firstName: string | null;
		lastName: string | null;
		publicMetadata?: Record<string, unknown>;
	} | null,
) => ({
	userPublicMetadataId: authUser?.publicMetadata?.id as number | undefined,
	userLogicalId: authUser?.publicMetadata?.logicalId as string | undefined,
	email:
		userInfo?.email || authUser?.emailAddresses[0]?.emailAddress || undefined,
	username: userInfo?.name ?? authUser?.username ?? undefined,
	firstName: userInfo?.firstName ?? authUser?.firstName ?? undefined,
	lastName: userInfo?.lastName ?? authUser?.lastName ?? undefined,
	isAdmin: authUser?.publicMetadata?.isAdmin === true,
});
